import { render, staticRenderFns } from "./PlayerControls.vue?vue&type=template&id=af11ff0a&scoped=true&"
import script from "./PlayerControls.vue?vue&type=script&lang=js&"
export * from "./PlayerControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayerControls.vue?vue&type=style&index=0&id=af11ff0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af11ff0a",
  null
  
)

export default component.exports